import React from 'react';

const brandColors: Record<string, [string, string]> = {
  'Samsung': ['#034EA2', '#00366D'],
  'Xiaomi': ['#FF6700', '#CC5200'],
  'Oppo': ['#007954', '#005D41'],
  'Huawei': ['#FF0000', '#CC0000'],
  'Apple': ['#000000', '#333333'],
  'Nokia': ['#124191', '#0C2B63'],
  'Sony': ['#000000', '#1A1A1A'],
  'OnePlus': ['#F5010C', '#C4010A'],
  'Google': ['#4285F4', '#3367D6'],
  'Default': ['#475569', '#334155']
};

interface FallbackSVGPhoneProps {
  modelName?: string;
  brandName?: string;
  className?: string;
}

const FallbackSVGPhone: React.FC<FallbackSVGPhoneProps> = ({ modelName = 'Smartphone', brandName = 'Marque', className = '' }) => {
  const [color1, color2] = brandColors[brandName] || brandColors['Default'];

  // Add a unique ID suffix to avoid gradient collision if there are multipleSVGs on same page
  const randomId = React.useId().replace(/:/g, "");

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400" width="100%" height="100%" className={`object-contain max-h-full drop-shadow-xl ${className}`}>
      <defs>
        <filter id={`shadow-${randomId}`} x="-10%" y="-10%" width="130%" height="130%">
          <feDropShadow dx="0" dy="15" stdDeviation="15" floodColor="#000" floodOpacity="0.15" />
        </filter>
        <linearGradient id={`screenGrad-${randomId}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1e293b" />
          <stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
        <linearGradient id={`bodyGrad-${randomId}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={color1} />
          <stop offset="100%" stopColor={color2} />
        </linearGradient>
        <linearGradient id={`glass-${randomId}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.15"/>
          <stop offset="50%" stopColor="#ffffff" stopOpacity="0.0"/>
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.0"/>
        </linearGradient>
      </defs>

      <rect x="20" y="20" width="160" height="340" rx="30" ry="30" fill={`url(#bodyGrad-${randomId})`} filter={`url(#shadow-${randomId})`} stroke="#475569" strokeWidth="2"/>
      <rect x="25" y="25" width="150" height="330" rx="25" ry="25" fill={`url(#screenGrad-${randomId})`}/>
      
      <path d="M 25 150 Q 80 100 175 140 L 175 330 Q 100 350 25 310 Z" fill={color1} opacity="0.3" />
      <path d="M 25 250 Q 100 200 175 280 L 175 355 L 25 355 Z" fill={color2} opacity="0.4" />
      <rect x="25" y="25" width="150" height="330" rx="25" ry="25" fill={`url(#glass-${randomId})`}/>
      
      <rect x="80" y="30" width="40" height="12" rx="6" ry="6" fill="#000"/>
      <circle cx="90" cy="36" r="2.5" fill="#111"/>
      <circle cx="90" cy="36" r="1" fill="#444"/>

      <rect x="180" y="90" width="3" height="30" rx="1.5" ry="1.5" fill="#94a3b8"/>
      <rect x="180" y="130" width="3" height="40" rx="1.5" ry="1.5" fill="#94a3b8"/>
      <rect x="17" y="100" width="3" height="30" rx="1.5" ry="1.5" fill="#94a3b8"/>

      <text x="100" y="100" fontFamily="system-ui, sans-serif" fontSize="28" fontWeight="900" fill="#ffffff" textAnchor="middle" dominantBaseline="middle">10:42</text>
      <text x="100" y="120" fontFamily="system-ui, sans-serif" fontSize="10" fill="#94a3b8" textAnchor="middle">
        {typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.startsWith('127.') ? window.location.hostname.replace('www.', '') : 'Votre boutique'}
      </text>

      <g transform="translate(100, 240)">
        <circle cx="0" cy="0" r="25" fill={color1} opacity="0.8" />
        <text x="0" y="5" fontFamily="system-ui, sans-serif" fontSize="16" fontWeight="900" fill="#ffffff" textAnchor="middle">{brandName.charAt(0).toUpperCase()}</text>
      </g>

      <g transform="translate(100, 300)">
        <text x="0" y="0" fontFamily="system-ui, sans-serif" fontSize="12" fontWeight="bold" fill="#ffffff" opacity="0.9" textAnchor="middle">{modelName.length > 20 ? modelName.substring(0, 18) + '...' : modelName}</text>
        <text x="0" y="15" fontFamily="system-ui, sans-serif" fontSize="9" fill="#94a3b8" opacity="0.8" textAnchor="middle">{brandName}</text>
      </g>
    </svg>
  );
};

export default FallbackSVGPhone;
